import { customElement, WebComponent } from '@/lib/components'

import styles from './DialogContent.styles.css'

@customElement('solid-ui-dialog-content')
export default class DialogContent extends WebComponent {
  static styles = styles
}
